/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Audio_Description_Export_Progress_LabelInputs */



/**
* | output |
* | --- |
* | "Exporting - {percent}%" |
*
* @param {Audio_Description_Export_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_progress_label = /** @type {((inputs: Audio_Description_Export_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Exportation - ${i?.percent}%`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Exportieren - ${i?.percent}%`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione - ${i?.percent}%`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт - ${i?.percent}%`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Exportando - ${i?.percent}%`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导出 - ${i?.percent}%`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`エクスポート中 - ${i?.percent}%`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`निर्यात - ${i?.percent}%`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Exportando - ${i?.percent}%`)
	return /** @type {LocalizedString} */ (`Exporting - ${i?.percent}%`)
});